import * as types from "./actionTypes";

export const getList = id => {
  return {
    type: types.GET_COST_CENTER_REQUEST,
    id
  };
};

export const getListSuccess = data => {
  return {
    type: types.GET_COST_CENTER_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = error => {
  return {
    type: types.GET_COST_CENTER_FAILURE,
    error: error
  };
};

export const show = id => {
  return {
    type: types.SHOW_COST_CENTER_REQUEST,
    id
  };
};

export const showSuccess = data => {
  return {
    type: types.SHOW_COST_CENTER_SUCCESS,
    payLoad: data
  };
};
export const showFailure = error => {
  return {
    type: types.SHOW_COST_CENTER_FAILURE,
    error: error
  };
};

export const remove = (id, goBack) => {
  return {
    type: types.REMOVE_COST_CENTER_REQUEST,
    id,
    goBack
  };
};

export const removeSuccess = data => {
  return {
    type: types.REMOVE_COST_CENTER_SUCCESS,
    payLoad: data
  };
};
export const removeFailure = () => {
  return {
    type: types.REMOVE_COST_CENTER_FAILURE
  };
};

export const store = data => {
  return {
    type: types.STORE_COST_CENTER_REQUEST,
    data
  };
};

export const storeSuccess = data => {
  return {
    type: types.STORE_COST_CENTER_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.STORE_COST_CENTER_FAILURE
  };
};

export const update = (id, data) => {
  return {
    type: types.UPDATE_COST_CENTER_REQUEST,
    id,
    data
  };
};

export const updateSuccess = data => {
  return {
    type: types.UPDATE_COST_CENTER_SUCCESS,
    payLoad: data
  };
};
export const updateFailure = () => {
  return {
    type: types.UPDATE_COST_CENTER_FAILURE
  };
};

export const clearList = () => {
  return {
    type: types.CLEAR_COST_CENTER_LIST
  };
};
